import { FormikHelpers, Formik } from "formik";
import RequiredField from "lib/components/common/required-field";
import SimpleDropdown from "lib/components/common/simple-dropdown";
import SimplePasswordField from "lib/components/common/simple-password";
import SimpleTextbox from "lib/components/common/simple-textbox";
import { CLINIC_USER_ROLES, USER_ROLES } from "lib/constants";
import {
  EMAIL_VALIDATION_SCHEMA,
  NAME_VALIDATION_SCHEMA,
} from "lib/constants/validation-constants";
import {
  getArrayFrom,
  getArrayOfKeyValuesFromArray,
  getArrayOfValuesFromArray,
  getPropsAsArrayFromArray,
} from "lib/utils/array-utils";
import { Button, Form } from "react-bootstrap";
import { FiEyeOff, FiEye } from "react-icons/fi";

interface AddUserFormProps {
  //passwordVisible: boolean;
  //setPasswordVisible: (visible: boolean) => void;
  errorMessage: string;
  DEFAULT_CLINIC_USER_FORM_VALUES: CreateUserRequest;
  onAddUser: (
    values: CreateUserRequest,
    formikHelpers: FormikHelpers<CreateUserRequest>
  ) => Promise<void>;
  //isLoading: boolean;
  clinics: Clinic[];
}

const AddUserForm: React.FC<AddUserFormProps> = ({
  //passwordVisible,
  //setPasswordVisible,
  errorMessage,
  DEFAULT_CLINIC_USER_FORM_VALUES,
  onAddUser,
  clinics,
  //isLoading,
}) => {
  return (
    <Formik
      initialValues={DEFAULT_CLINIC_USER_FORM_VALUES}
      onSubmit={onAddUser}
    >
      {({
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        errors,
        touched,
      }) => (
        <Form onSubmit={handleSubmit}>
          <SimpleTextbox
            label="First Name"
            type="text"
            name="firstName"
            value={values.firstName}
            onChange={handleChange}
            required
            validationSchema={NAME_VALIDATION_SCHEMA(
              "Please provide first name"
            )}
          />

          <SimpleTextbox
            label="Last Name"
            type="text"
            name="lastName"
            value={values.lastName}
            onChange={handleChange}
            required
            validationSchema={NAME_VALIDATION_SCHEMA(
              "Please provide last name"
            )}
          />
          <SimpleTextbox
            label="Email address"
            type="email"
            name="email"
            value={values.email}
            className="form-control"
            onChange={handleChange}
            required
            validationSchema={EMAIL_VALIDATION_SCHEMA}
          />

          <SimpleDropdown
            label="Role"
            options={getArrayFrom(CLINIC_USER_ROLES).toUppercase()}
            values={getArrayFrom(CLINIC_USER_ROLES)}
            name="role"
            selectedValue={values.role}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {/* <Form.Group className="form-group">
            <Form.Label>
              Role <RequiredField />
            </Form.Label>
            <Form.Control
              as="select"
              name="role"
              value={values.role}
              onChange={(e) => {
                handleChange(e);
              }}
            >
              {getArrayFrom<string>(CLINIC_USER_ROLES).map((role) => (
                <option key={role} value={role} selected={role === values.role}>
                  {role.toUpperCase()}
                </option>
              ))}
            </Form.Control>
          </Form.Group> */}

          {/* <SimplePasswordField
            isShowVisibilityIcon
            name="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={touched.password && !!errors.password}
          /> */}
          {/* <Form.Group className="form-group position-relative">
            <Form.Label>
              Password <RequiredField />
            </Form.Label>
            <Form.Control
              type={passwordVisible ? "text" : "password"}
              name="password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={touched.password && !!errors.password}
            />
            <span
              className="toggle-password position-absolute"
              style={{
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
              onClick={() => setPasswordVisible(!passwordVisible)}
            >
              {passwordVisible ? <FiEyeOff /> : <FiEye />}
            </span>
            <Form.Control.Feedback type="invalid">
              {errors.password}
            </Form.Control.Feedback>
          </Form.Group> */}

          <SimpleDropdown
            label="Clinics"
            id="clinicIds"
            multiple
            options={getPropsAsArrayFromArray<Clinic, "name">(clinics, "name")}
            values={getPropsAsArrayFromArray<Clinic, "id">(clinics, "id")}
            selectedValue={values.clinicIds}
            onChange={handleChange}
            required
          />

          {errorMessage && (
            <div className="text-danger text-center mb-3">{errorMessage}</div>
          )}

          <Form.Group className="text-center">
            <Button type="submit" className="btn btn-primary px-4">
              Add User
            </Button>
          </Form.Group>
        </Form>
      )}
    </Formik>
  );
};

export default AddUserForm;
